import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { FaTelegram, FaLinkedin } from "react-icons/fa";
import Mickey_pic from "../assets/Mickey_pic.png";

const About = () => {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 gradient-bg opacity-30" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(99,102,241,0.15),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(168,85,247,0.1),transparent_50%)]" />

      <div className="relative container-custom p-6 w-full">
        <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-12">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex-1 text-center md:text-left"
          >
            <p className="text-primary-400 font-medium mb-4 tracking-wider text-sm md:text-base">
              Hello, I'm
            </p>
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold tracking-tight mb-4">
              <span className="text-white">Dagmawi</span>{" "}
              <span className="gradient-text">Ephrem</span>
            </h1>

            <div className="h-12 md:h-14 mb-6">
              <TypeAnimation
                className="text-xl md:text-2xl lg:text-3xl font-semibold gradient-text"
                sequence={[
                  "Full-Stack Developer",
                  2000,
                  "AI & ML Enthusiast",
                  2000,
                  "Open Source Contributor",
                  2000,
                  "Problem Solver",
                  2000,
                ]}
                speed={50}
                repeat={Infinity}
              />
            </div>

            <p className="text-gray-400 text-base md:text-lg max-w-2xl mx-auto md:mx-0 mb-8 leading-relaxed">
              I craft impactful digital experiences through clean code and creative solutions.
              Currently pursuing Information Science, I thrive at the intersection of
              <span className="text-primary-400"> full-stack development</span>,
              <span className="text-purple-400"> artificial intelligence</span>, and
              <span className="text-pink-400"> innovative design</span>.
            </p>

            <div className="flex flex-wrap items-center gap-4 justify-center md:justify-start">
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector("#contact");
                  if (el) {
                    const headerOffset = 80;
                    const elementPosition = el.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({ top: offsetPosition, behavior: "smooth" });
                  }
                }}
                className="btn-primary"
              >
                Get In Touch
              </a>
              <div className="flex items-center gap-3">
                <a
                  href="https://t.me/dagi_0056"
                  target="_blank"
                  rel="noreferrer"
                  className="p-3 glass rounded-full text-gray-400 hover:text-sky-400 hover:border-sky-500/30 hover:shadow-lg hover:shadow-sky-500/20 hover:-translate-y-0.5 transition-all duration-300"
                  aria-label="Telegram"
                >
                  <FaTelegram className="w-5 h-5" />
                </a>
                <a
                  href="https://www.linkedin.com/in/dagmawi-ephrem-559a7b342"
                  target="_blank"
                  rel="noreferrer"
                  className="p-3 glass rounded-full text-gray-400 hover:text-blue-400 hover:border-blue-500/30 hover:shadow-lg hover:shadow-blue-500/20 hover:-translate-y-0.5 transition-all duration-300"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin className="w-5 h-5" />
                </a>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
            className="flex-shrink-0"
          >
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-primary-500 via-purple-500 to-pink-500 rounded-full blur-3xl opacity-30 animate-float" />
              <div className="relative w-72 sm:w-80 ">
                <img
                  src={Mickey_pic}
                  alt="Dagmawi Ephrem"
                  className="w-full h-full object-contain rounded-2xl"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 glass rounded-2xl px-5 py-3">
                <p className="text-sm font-medium text-white">2+ Years</p>
                <p className="text-xs text-gray-400">Development</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
